import { c as _c } from "react/compiler-runtime";
import { shopAsset } from '@utils/utils-config';
import Image from 'next/image';
type TrustedLogoProps = {
  className?: string;
  width?: number;
  height?: number;
};
export const TrustedLogo = t0 => {
  const $ = _c(5);
  const {
    className,
    width: t1,
    height: t2
  } = t0;
  const width = t1 === undefined ? 20 : t1;
  const height = t2 === undefined ? 20 : t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = shopAsset("/images/trusted-shops-logo.webp");
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== className || $[2] !== height || $[3] !== width) {
    t4 = <Image unoptimized={true} src={t3} alt="TrustedShops" className={className} width={width} height={height} />;
    $[1] = className;
    $[2] = height;
    $[3] = width;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};